import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Pagination = ({
    pageSize,
    onPageSizeChange,
    currentPage,
    onPageChange,
    totalPages,
    totalItems
}) => {
    return (
        <div className='d-flex justify-content-between align-items-center c-pagination'>
            <div className="p-tag d-flex align-items-center text-nowrap">
                Show
                <select 
                    className="form-select mx-2" 
                    style={{ minWidth: 70 }}
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                </select>
                per page ({totalItems} total)
            </div>
            <div className='d-flex align-items-center gap-2 p-tag'>
                <div className='text-nowrap'>
                    {Math.min((currentPage - 1) * pageSize + 1, totalItems)} to {Math.min(currentPage * pageSize, totalItems)} of {totalItems} Pages
                </div>
                <select 
                    className='form-select' 
                    style={{ minWidth: 70 }}
                    value={currentPage}
                    onChange={(e) => onPageChange(Number(e.target.value))}
                >
                    {[...Array(totalPages)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                </select>
                <Button 
                    variant="btn"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    <i className="fas fa-chevron-left"></i>
                </Button>
                <Button 
                    variant="btn"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    <i className="fas fa-chevron-right"></i>
                </Button>
            </div>
        </div>
    );
};

Pagination.propTypes = {
    pageSize: PropTypes.number.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    totalPages: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired
};

export default Pagination;
